import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import {
  Navigation,
  Scrollbar,
  A11y,
  EffectFade,
  Autoplay,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

const BannerOne = ({ id, DataBannerOne }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openVideo = () => {
    setIsOpen(true);
  };

  const closeVideo = () => {
    setIsOpen(false);
  };

  const handleKeyUp = (e) => {
    if (e.key === "Escape") {
      closeVideo();
    }
  };

  return (
    <div className="tmp-banner-swiper-one-area" id={id}>
      <Swiper
        // install Swiper modules
        modules={[Navigation, EffectFade, Scrollbar, A11y, Autoplay]}
        className="mySwiper-banner-one"
        speed={500}
        slidesPerView={1}
        spaceBetween={0}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        effect="fade"
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        breakpoints={{
          1200: { slidesPerView: 1 },
          900: { slidesPerView: 1 },
          768: { slidesPerView: 1 },
          580: { slidesPerView: 1 },
          450: { slidesPerView: 1 },
          0: { slidesPerView: 1 },
        }}
      >
        {DataBannerOne?.map((item) => {
          const { id, cl_bg_image, subTitle, title, desc, link } = item;
          console.log(cl_bg_image);

          return (
            <SwiperSlide key={id}>
              <div
                className={`tmp-banner-area ${cl_bg_image} bg_image banner-one-height-control tmp-section-gap`}
              >
                <div className="shape-image-banner-one">
                  <img
                    src="assets/images/banner/shape/01.png"
                    alt="banner"
                    className="one"
                  />
                  <img
                    src="assets/images/banner/shape/02.png"
                    alt="banner"
                    className="two"
                  />
                  <img
                    src="assets/images/banner/shape/03.png"
                    alt="banner"
                    className="three"
                  />
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="banner-one-main-wrapper">
                        <div className="inner">
                          <span className="sub-title">
                            {subTitle.toUpperCase()}
                          </span>
                          <h1 className="title">{title}</h1>
                          <p className="disc">{desc}</p>
                          <div className="button-area-banner-one">
                            <Link to={link} className="tmp-btn btn-primary">
                              En Savoir +
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}

        <div className="swiper-button-next"></div>
        <div className="swiper-button-prev"></div>
      </Swiper>
    </div>
  );
};

export default BannerOne;
